// material-ui
import { styled, TextField } from '@mui/material';
// types
import { InputProps } from './types';

export const StyledTextField = styled(TextField)<InputProps>`
  ${({ adornmentdivider }) =>
    adornmentdivider &&
    `
    & .MuiInputBase-input {
      padding-left: 70px;
    }
  `}
`;
